var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calculator" },
    [
      _c("Search", {
        attrs: {
          id: "efficiency-calc-search",
          placeholder: _vm.$t("labelCalculator"),
          query: _vm.query,
          results: _vm.filteredProducts,
          "min-query-length": 1
        },
        on: {
          input: function($event) {
            _vm.query = $event
          },
          selectItem: _vm.handleSelectItem
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.modalOpen
            ? _c("Modal", {
                attrs: { categoryProps: _vm.categoryProps },
                on: { closeModal: _vm.handleModalClose },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("header", { staticClass: "modal__header" }, [
                            _c("h3", {
                              staticClass: "modal__title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("calculatorTitle"))
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "modal__subtitle",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("calculatorSubitle"))
                              }
                            })
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("calculatorProductName")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("calculatorEfficiency")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("calculatorPriceGross")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "cl-black product-link underline",
                                      attrs: {
                                        to: _vm.productLink,
                                        "data-testid": "productLink"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.selectedItem.part_number ||
                                              _vm.selectedItem.name
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.selectedItem.wydajnosc) +
                                    " " +
                                    _vm._s(_vm.$t("calculatorPage"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("price")(
                                      _vm.selectedItem.final_price,
                                      _vm.storeView
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "cl-black product-link underline",
                                      attrs: {
                                        to: _vm.productLink,
                                        "data-testid": "productLink"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.selectedItem.kod_oem) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.selectedItem.wydajnosc_oem) +
                                    " " +
                                    _vm._s(_vm.$t("calculatorPage"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("BaseCurrency", {
                                    attrs: {
                                      id: _vm.grossOEMEditable || "currency"
                                    },
                                    on: {
                                      keydownEnter: function($event) {
                                        return _vm.calculate(_vm.selectedItem)
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function() {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "icon-wrapper",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.calculate(
                                                        _vm.selectedItem
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM12 20C7.6 20 4 16.4 4 12C4 11.4 4.5 11 5 11C5.5 11 6 11.4 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6C10.7 6 9.5 6.4 8.4 7.2H8.8C9.3 7.2 9.8 7.6 9.8 8.2C9.8 8.7 9.3 9.2 8.8 9.2H5.6C5.3 9.2 5 9.1 4.8 8.8C4.6 8.6 4.5 8.3 4.6 8L5.2 4.8C5.2 4.7 5.3 4.6 5.3 4.5C5.4 4.3 5.6 4.2 5.8 4.1C6.1 4 6.3 4 6.5 4C7 4.1 7.4 4.6 7.3 5.2L7.2 5.6C8.5 4.6 10.2 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20Z",
                                                          fill: "#00BFFB"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      35967718
                                    ),
                                    model: {
                                      value: _vm.grossOEMEditable,
                                      callback: function($$v) {
                                        _vm.grossOEMEditable = $$v
                                      },
                                      expression: "grossOEMEditable"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "results" },
                            [
                              _c("BaseFigure", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "image",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "image-wrapper" },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "83",
                                                    height: "101",
                                                    viewBox: "0 0 83 101",
                                                    fill: "none",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M47.7545 52.9134C47.732 52.9134 47.732 52.9134 47.732 52.9134V13.7789C47.732 6.87815 37.4062 1.4834 24.1946 1.4834C11.0055 1.4834 0.679688 6.87815 0.679688 13.7789V79.3252C0.679688 86.2259 11.0055 91.6207 24.1946 91.6207C24.4426 91.6207 24.7131 91.5982 24.9386 91.5982C25.0513 91.5982 25.1415 91.5982 25.2542 91.5757C28.2077 96.7457 37.2258 100.23 47.7545 100.23C60.9436 100.23 71.2694 94.8351 71.2694 87.9343V65.2089C71.2694 58.3081 60.9436 52.9134 47.7545 52.9134ZM4.15168 74.7396C8.39022 78.3586 15.8302 80.5165 24.1946 80.5165C24.2171 80.5165 24.2171 80.5165 24.2397 80.5165V87.9568C24.2397 88.0242 24.2397 88.0916 24.2622 88.1591C24.2397 88.1591 24.2397 88.1591 24.2171 88.1591C12.2229 88.1591 4.17423 83.596 4.17423 79.3252V74.7396H4.15168ZM4.15168 68.221V64.1749C8.39022 67.7939 15.8302 69.9518 24.1946 69.9518C24.2171 69.9518 24.2171 69.9518 24.2397 69.9518V77.0324C24.2171 77.0324 24.2171 77.0324 24.1946 77.0324C12.2004 77.0324 4.15168 72.4693 4.15168 68.221ZM24.2171 65.2089V66.4677C24.1946 66.4677 24.1946 66.4677 24.172 66.4677C12.1779 66.4677 4.12914 61.9046 4.12914 57.6338V53.6102C8.39022 57.2292 15.8077 59.3871 24.172 59.3871C25.0513 59.3871 25.9982 59.3646 27.0353 59.2971C25.1866 61.0954 24.2171 63.1184 24.2171 65.2089ZM4.15168 47.0915V43.0679C8.39022 46.6869 15.8302 48.8448 24.1946 48.8448C32.5589 48.8448 39.9989 46.6869 44.2374 43.0679V47.0915C44.2374 51.3624 36.1887 55.9254 24.1946 55.9254C12.2004 55.9029 4.15168 51.3399 4.15168 47.0915ZM24.1946 45.3382C12.2004 45.3382 4.15168 40.7752 4.15168 36.5043V32.4583C8.39022 36.0772 15.8302 38.2351 24.1946 38.2351C32.5589 38.2351 39.9989 36.0772 44.2374 32.4583V36.5043C44.2374 40.7752 36.1662 45.3382 24.1946 45.3382ZM44.2374 25.9621C44.2374 30.2329 36.1887 34.796 24.1946 34.796C12.2004 34.796 4.15168 30.2329 4.15168 25.9621V20.3201C4.46732 20.5898 4.8055 20.8595 5.18877 21.1293C5.3015 21.2192 5.41423 21.2866 5.52695 21.3765L5.68477 21.4889C6.18077 21.8261 6.69932 22.1408 7.26295 22.433C7.30804 22.4555 7.33059 22.478 7.37568 22.5004C7.42077 22.5229 7.44332 22.5454 7.48841 22.5679C8.07459 22.8826 8.7284 23.1748 9.5175 23.4895C9.65277 23.5344 9.78804 23.6019 9.92331 23.6468L10.1037 23.7143C10.6222 23.9166 11.1859 24.1189 11.8171 24.3212L12.0426 24.3886C12.2004 24.4336 12.3582 24.4785 12.516 24.5235C13.2826 24.7483 14.0266 24.9506 14.7931 25.1079C14.8157 25.1079 14.8608 25.1304 14.8833 25.1304C14.9284 25.1304 14.9509 25.1529 14.9735 25.1529C15.74 25.3102 16.5968 25.4676 17.6113 25.6249C17.7466 25.6474 17.8818 25.6699 18.0397 25.6699C18.1524 25.6923 18.2651 25.6923 18.4004 25.7148C19.1669 25.8047 19.8433 25.8722 20.4971 25.9396L20.7451 25.9621C20.948 25.9846 21.1284 25.9846 21.3088 26.007C22.0978 26.052 23.1575 26.097 24.2397 26.097C25.3218 26.097 26.3589 26.052 27.1706 26.007C27.3735 26.007 27.5538 25.9846 27.7567 25.9621L28.0273 25.9396C28.636 25.8946 29.3124 25.8272 30.1015 25.7148C30.2142 25.6923 30.3495 25.6923 30.4622 25.6699C30.5975 25.6474 30.7327 25.6249 30.8906 25.6249C31.8826 25.4676 32.7393 25.3327 33.5058 25.1529C33.5509 25.1529 33.5735 25.1304 33.6186 25.1304C33.6411 25.1304 33.6636 25.1079 33.7087 25.1079C34.4302 24.9506 35.1742 24.7483 35.9858 24.5235C36.1436 24.4785 36.3015 24.4336 36.4367 24.3886L36.6622 24.3212C37.2484 24.1189 37.812 23.939 38.3531 23.7143L38.5335 23.6468C38.6687 23.6019 38.804 23.5344 38.9393 23.4895C39.7058 23.1748 40.3822 22.8601 40.9684 22.5679C41.0135 22.5454 41.0585 22.5229 41.1036 22.478C41.1262 22.4555 41.1713 22.433 41.1938 22.433C41.7349 22.1408 42.2309 21.8486 42.7495 21.4889C42.9073 21.3765 43.0651 21.2866 43.2229 21.1742L43.2455 21.1518C43.6062 20.9045 43.9444 20.6348 44.2825 20.3425V25.9621H44.2374ZM24.1946 22.6128C12.2004 22.6128 4.15168 18.0498 4.15168 13.7789C4.15168 9.50809 12.2004 4.94503 24.1946 4.94503C36.1887 4.94503 44.2374 9.50809 44.2374 13.7789C44.2374 18.0498 36.1662 22.6128 24.1946 22.6128ZM47.7545 86.2035C35.7604 86.2035 27.7117 81.6404 27.7117 77.3696V71.7051C28.0273 71.9748 28.3655 72.2445 28.7487 72.5143C28.9066 72.6267 29.0644 72.7391 29.2447 72.8515C29.7633 73.2111 30.3044 73.5258 30.8004 73.7955C30.8455 73.818 30.868 73.8405 30.8906 73.863C30.9356 73.8855 30.9807 73.9079 31.0258 73.9304C31.6346 74.2451 32.3109 74.5598 33.0324 74.852C33.1676 74.9194 33.3029 74.9644 33.4382 75.0094C33.5058 75.0318 33.5735 75.0543 33.6411 75.0768C34.2724 75.3241 34.8135 75.5039 35.3546 75.6837C35.4447 75.7062 35.5349 75.7511 35.6251 75.7736C35.7604 75.8186 35.8956 75.8635 36.0309 75.9085C36.8651 76.1557 37.5866 76.3356 38.2855 76.4929H38.3305C38.3982 76.5154 38.4433 76.5154 38.4884 76.5379C39.2549 76.6952 40.1116 76.8526 41.1262 77.0099C41.3742 77.0324 41.6447 77.0773 41.8927 77.0998C42.6818 77.1897 43.3356 77.2572 43.9669 77.3021L44.1924 77.3246C44.3953 77.3471 44.5982 77.3696 44.8011 77.3696C45.5902 77.4145 46.6273 77.4595 47.732 77.4595C48.8142 77.4595 49.8513 77.4145 50.6404 77.3696C50.8658 77.3471 51.0913 77.3246 51.3167 77.3246L51.4745 77.3021C52.1283 77.2572 52.8047 77.1897 53.5713 77.0998C53.8193 77.0549 54.0898 77.0324 54.3603 77.0099C55.3523 76.8526 56.2091 76.6952 56.9756 76.5379C57.0433 76.5154 57.1109 76.5154 57.156 76.4929C57.8774 76.3356 58.6214 76.1333 59.4331 75.9085C59.5683 75.8635 59.7036 75.8186 59.8389 75.7961C59.9291 75.7736 60.0418 75.7287 60.132 75.7062C60.6505 75.5488 61.1691 75.369 61.8454 75.0993C61.9131 75.0768 61.9807 75.0543 62.0483 75.0318C62.1836 74.9869 62.3189 74.9194 62.4316 74.8745C63.1756 74.5823 63.852 74.2676 64.4381 73.9529C64.4832 73.9304 64.5509 73.9079 64.596 73.863C64.6185 73.8405 64.6636 73.818 64.6862 73.818C65.2272 73.5258 65.7458 73.2111 66.2418 72.8739C66.3771 72.784 66.4898 72.6941 66.6025 72.6267L66.7378 72.5368C67.1211 72.267 67.4592 71.9973 67.7749 71.7276V77.3696C67.7749 81.6404 59.7262 86.2035 47.7545 86.2035ZM47.7545 74.0203C35.7604 74.0203 27.7117 69.4573 27.7117 65.2089C27.7117 60.938 35.7604 56.375 47.7545 56.375C59.7487 56.375 67.7974 60.938 67.7974 65.2089C67.7749 69.4797 59.7262 74.0203 47.7545 74.0203ZM67.7749 83.9107V87.9343C67.7749 92.2051 59.7262 96.7682 47.732 96.7682C35.7378 96.7682 27.6891 92.2051 27.6891 87.9343V83.9107C31.9276 87.5297 39.3676 89.6876 47.732 89.6876C56.1189 89.6876 63.5363 87.5297 67.7749 83.9107Z",
                                                      fill: "#F0047F"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M81.5075 18.8816C80.7635 18.1398 79.546 18.1398 78.8021 18.8816L69.7388 27.9178V1.91064C69.7388 0.854169 68.8821 0 67.8224 0C66.7628 0 65.9061 0.854169 65.9061 1.91064V28.0752L56.7752 18.9715C56.0312 18.2298 54.8137 18.2298 54.0697 18.9715C53.3257 19.7133 53.3257 20.9271 54.0697 21.6689L67.7548 35.3131L81.53 21.579C82.274 20.8372 82.274 19.6234 81.5075 18.8816Z",
                                                      fill: "#F0047F"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "caption",
                                      fn: function() {
                                        return [
                                          _c("div", { staticClass: "result" }, [
                                            _vm._v(_vm._s(_vm.printSavings))
                                          ]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("calculatorPrintSavings")
                                              )
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1811037354
                                )
                              }),
                              _vm._v(" "),
                              _c("BaseFigure", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "image",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "image-wrapper" },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "97",
                                                    height: "86",
                                                    viewBox: "0 0 97 86",
                                                    fill: "none",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M23.2852 25.9243C23.2852 40.2498 34.9168 51.8487 49.2827 51.8487C63.6486 51.8487 75.2803 40.2498 75.2803 25.9243C75.2803 11.5989 63.6486 0 49.2827 0C34.9392 0.0223486 23.3076 11.6213 23.2852 25.9243ZM49.2827 3.57577C61.654 3.57577 71.6944 13.5879 71.6944 25.9243C71.6944 38.2608 61.654 48.2729 49.2827 48.2729C36.9115 48.2729 26.871 38.2608 26.871 25.9243C26.8934 13.5879 36.9115 3.59812 49.2827 3.57577Z",
                                                      fill: "#F0047F"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M84.1116 56.2514L70.0595 62.8665C68.1096 59.2684 64.4117 56.9889 60.3104 56.8548L47.334 56.4972C45.2721 56.4301 43.2775 55.9161 41.4397 54.9775L40.1174 54.307C33.3715 50.7983 25.3033 50.7983 18.5574 54.3294L18.647 51.357C18.6694 50.3737 17.885 49.5468 16.8989 49.5244L2.68987 49.1445C1.70376 49.1222 0.874526 49.9044 0.852114 50.8877L0.000468544 81.9969C-0.0219432 82.9802 0.762467 83.8071 1.74858 83.8295L15.9576 84.2094H16.0024C16.9661 84.2094 17.7729 83.4496 17.7954 82.4662L17.8402 80.9689L21.5381 79.0022C22.9949 78.22 24.6758 78.0412 26.267 78.4882L48.3201 84.6564C48.3649 84.6564 48.3873 84.6787 48.4322 84.6787C50.0234 85.014 51.6594 85.1704 53.2731 85.1704C56.7245 85.1704 60.1311 84.4329 63.2687 83.0026C63.3359 82.9579 63.4256 82.9356 63.4928 82.8909L95.4743 62.2631C96.2812 61.7491 96.5277 60.6987 96.057 59.8718C93.7038 55.6926 88.437 54.0835 84.1116 56.2514ZM3.65358 80.2984L4.41557 52.765L15.0387 53.0555L14.2767 80.589L3.65358 80.2984ZM61.6775 79.8291C57.7778 81.5723 53.43 82.064 49.239 81.2147L27.2531 75.0689C24.7878 74.376 22.1208 74.6666 19.8572 75.8734L17.9747 76.8791L18.4901 58.5756C24.474 54.6199 32.1389 54.1953 38.5038 57.5029L39.8261 58.1733C42.1345 59.3578 44.667 60.0059 47.2668 60.0953L60.2431 60.4529C63.8962 60.5646 66.9891 63.1347 67.7286 66.7105L48.4098 66.1741C47.4236 66.1518 46.5944 66.934 46.572 67.9173C46.5496 68.9006 47.334 69.7275 48.3201 69.7499L69.6336 70.331C69.656 70.331 69.656 70.331 69.6785 70.331C70.6422 70.331 71.449 69.5488 71.4714 68.5878C71.4938 67.8056 71.4266 67.0234 71.2921 66.2635L85.7028 59.4696C85.7252 59.4696 85.7252 59.4472 85.7477 59.4472C87.7871 58.4192 90.2524 58.7544 91.9333 60.3188L61.6775 79.8291Z",
                                                      fill: "#F0047F"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M47.6041 43.9376V39.4232C45.0043 39.3785 42.3149 38.5739 40.7461 37.4565L41.8219 34.4618C43.4355 35.5345 45.7663 36.3837 48.2764 36.3837C51.4589 36.3837 53.6104 34.5512 53.6104 32.0034C53.6104 29.5451 51.8623 28.0254 48.5454 26.6845C43.9734 24.8966 41.1495 22.8405 41.1495 18.9519C41.1495 15.242 43.7941 12.4261 47.9178 11.7556V7.24121H50.6969V11.5768C53.3863 11.6662 55.224 12.3814 56.5239 13.1412L55.4033 16.0912C54.4621 15.5549 52.6243 14.5715 49.7556 14.5715C46.3042 14.5715 45.0043 16.6276 45.0043 18.4155C45.0043 20.7397 46.6628 21.9019 50.5624 23.511C55.1792 25.3883 57.51 27.7125 57.51 31.6905C57.51 35.2216 55.0448 38.5292 50.4279 39.2891V43.9376H47.6041Z",
                                                      fill: "#F0047F"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "caption",
                                      fn: function() {
                                        return [
                                          _c("div", { staticClass: "result" }, [
                                            _vm._v(_vm._s(_vm.tonerSavings))
                                          ]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("calculatorTonerSavings")
                                              )
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  661300880
                                )
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  4059999161
                )
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }